import { defineStore } from "pinia";
import { showError } from "src/utils/notify";

export const useGiftStore = defineStore("gift", {
  state: () => ({
    giftReceivedList: [],
    loadGiftReceived: false,
    giftSentList: [],
    loadGiftSent: false,
    giftRedeemedList: [],
    loadGiftRedeemed: false,
    giftDetail: {},
    loadGiftDetail: false,
  }),
  getters: {},
  actions: {
    async getGiftReceivedData(params, options) {
      try {
        if (params.page == 1) {
          this.resetGiftReceivedData();
        }
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.GIFT_RECEIVED;
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_GIFT_RECEIVED;
            break;
        }
        if (URL) {
          response = await this.$request.post(URL, {
            page: params.page,
            per_page: params.per_page,
          });
          if (response.data) {
            Array.prototype.push.apply(
              this.giftReceivedList,
              response.data.items
            );
            this.loadGiftReceived = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        showError(error.message);
      }
    },
    resetGiftReceivedData() {
      this.giftReceivedList = [];
      this.loadGiftReceived = false;
    },
    async getGiftSentData(params, options) {
      try {
        if (params.page == 1) {
          this.resetGiftSentData();
        }
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.GIFT_SENT;
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_GIFT_SENT;
            break;
        }
        if (URL) {
          response = await this.$request.post(URL, {
            page: params.page,
            per_page: params.per_page,
          });
          if (response.data) {
            Array.prototype.push.apply(this.giftSentList, response.data.items);
            this.loadGiftSent = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        showError(error.message);
      }
    },
    resetGiftSentData() {
      this.giftSentList = [];
      this.loadGiftSent = false;
    },
    async getGiftRedeemedData(params, options) {
      try {
        if (params.page == 1) {
          this.resetGiftRedeemedData();
        }
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.GIFT_REDEEMED;
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_GIFT_REDEEMED;
            break;
        }
        if (URL) {
          response = await this.$request.post(URL, {
            page: params.page,
            per_page: params.per_page,
          });
          if (response.data) {
            Array.prototype.push.apply(
              this.giftRedeemedList,
              response.data.items
            );
            this.loadGiftRedeemed = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        showError(error.message);
      }
    },
    resetGiftRedeemedData() {
      this.giftRedeemedList = [];
      this.loadGiftRedeemed = false;
    },
    async getGiftDetail(id, options) {
      try {
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.GIFT_DETAIL(id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_GIFT_DETAIL(id);
            break;
        }
        if (URL) {
          response = await this.$request.get(URL);
          if (response.data) {
            this.giftDetail = response.data.item;
            this.loadGiftDetail = true;
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        showError(error.message);
      }
    },
    resetGiftDetail() {
      this.giftDetail = {};
      this.loadGiftDetail = false;
    },
    async acceptGift(params, options) {
      try {
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.GIFT_ACCEPT(options.id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_GIFT_ACCEPT(options.id);
            break;
        }
        if (URL) {
          response = await this.$request.post(URL, params);
          if (
            options.removeOnSuccess &&
            response &&
            response.data &&
            response.data.status
          ) {
            let giftIndex = this.giftReceivedList.findIndex(
              (gift) => gift.id === options.id
            );
            if (giftIndex != -1) {
              this.giftReceivedList.splice(giftIndex, 1);
            }
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        showError(error.message);
      }
    },
    async declineGift(options) {
      try {
        let URL, response;
        switch (options.category) {
          case "store":
            URL = this.apiEndpoints.GIFT_DECLINE(options.id);
            break;
          case "mfg":
            URL = this.apiEndpoints.MFG_GIFT_DECLINE(options.id);
            break;
        }
        if (URL) {
          response = await this.$request.post(URL);
          if (
            options.removeOnSuccess &&
            response &&
            response.data &&
            response.data.status
          ) {
            let giftIndex = this.giftReceivedList.findIndex(
              (gift) => gift.id === options.id
            );
            if (giftIndex != -1) {
              this.giftReceivedList.splice(giftIndex, 1);
            }
          }
          return response.data;
        } else {
          return {};
        }
      } catch (error) {
        showError(error.message);
      }
    },
  },
});
